/* tslint:disable */
/* eslint-disable */
/* Mocked in-memory implementation of TransactionsClient for local development and UI wiring. */

import { CancelToken } from 'axios';
import {
  SuccessResponse_1OfPagedData_1OfProductTransactionSearch,
  SuccessResponse_1OfRAG,
  CreateMultipleTransactionsRequest,
  CreatePosTransactionsRequest,
  CreateTransactionRequest,
  CreateMultiplePosTransactionsRequest,
  CreateSourceTransactionDataRequest,
  ProductTransactionSearch,
  SuccessResponse_1OfIEnumerable_1OfPosFeedLastReceived,
  FactId,
  SuccessResponse_1OfList_1OfNetSales,
} from '../../types';

/* ---- Helper Functions ---- */

function delay(ms: number = 300): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

function successResponse<T>(data: T): { data: T; success: boolean; message: string } {
  return { data, success: true, message: 'Success' };
}

/* ---- Mock Data ---- */

const mockTransactions: (ProductTransactionSearch & { documentId?: number })[] = [
  {
    transactionId: 1,
    transactionDay: 20251212,
    productId: 101,
    productItemNumber: 'MILK-001',
    productItemDescription: 'Whole Milk 2L',
    productQuantity: -10,
    productUom: 'EA',
    storeNumber: 'STORE001',
    type: 'Sales',
    source: 'POS',
    direction: 'Out',
    reason: '',
    sourceTransactionId: 'POS-20251212-001',
    transactionTime: '2025-12-12T10:30:00Z',
    createdBy: 'system',
    createdAt: '2025-12-12T10:30:00Z',
    costPrice: 1.50,
    totalSalePriceNet: 2.49,
    totalSalePriceGross: 2.99,
    isBom: false,
    match: true,
    documentId: 1001,
  },
  {
    transactionId: 2,
    transactionDay: 20251212,
    productId: 102,
    productItemNumber: 'BREAD-001',
    productItemDescription: 'White Bread 800g',
    productQuantity: -5,
    productUom: 'EA',
    storeNumber: 'STORE001',
    type: 'Waste',
    source: 'Manual',
    direction: 'Out',
    reason: 'Expired',
    transactionTime: '2025-12-12T14:15:00Z',
    createdBy: 'john.doe',
    createdAt: '2025-12-12T14:15:00Z',
    costPrice: 0.85,
    productNote: 'Past best before date',
    isBom: false,
    match: true,
  },
  {
    transactionId: 3,
    transactionDay: 20251211,
    productId: 101,
    productItemNumber: 'MILK-001',
    productItemDescription: 'Whole Milk 2L',
    productQuantity: 24,
    productUom: 'EA',
    storeNumber: 'STORE001',
    type: 'Receipt',
    source: 'PO',
    direction: 'In',
    reason: 'Purchase Order',
    sourceTransactionId: 'PO-2025-456',
    transactionTime: '2025-12-11T08:00:00Z',
    createdBy: 'system',
    createdAt: '2025-12-11T08:00:00Z',
    costPrice: 1.50,
    isBom: false,
    match: true,
  },
  {
    transactionId: 4,
    transactionDay: 20251211,
    productId: 103,
    productItemNumber: 'COFFEE-001',
    productItemDescription: 'Espresso Blend 1kg',
    productQuantity: -50,
    productUom: 'EA',
    storeNumber: 'STORE001',
    type: 'Sales',
    source: 'POS',
    direction: 'Out',
    reason: '',
    sourceTransactionId: 'POS-20251211-023',
    transactionTime: '2025-12-11T15:45:00Z',
    createdBy: 'system',
    createdAt: '2025-12-11T15:45:00Z',
    costPrice: 8.50,
    totalSalePriceNet: 14.99,
    totalSalePriceGross: 17.99,
    isBom: false,
    match: true,
    documentId: 1002,
  },
  {
    transactionId: 5,
    transactionDay: 20251211,
    productId: 104,
    productItemNumber: 'EGGS-001',
    productItemDescription: 'Free Range Eggs 12pk',
    productQuantity: -3,
    productUom: 'EA',
    storeNumber: 'STORE001',
    type: 'Waste',
    source: 'Manual',
    direction: 'Out',
    reason: 'Damaged',
    transactionTime: '2025-12-11T11:20:00Z',
    createdBy: 'jane.smith',
    createdAt: '2025-12-11T11:20:00Z',
    costPrice: 3.25,
    productNote: 'Box dropped during stocking',
    isBom: false,
    match: true,
  },
  {
    transactionId: 6,
    transactionDay: 20251210,
    productId: 105,
    productItemNumber: 'BUTTER-001',
    productItemDescription: 'Salted Butter 250g',
    productQuantity: 48,
    productUom: 'EA',
    storeNumber: 'STORE001',
    type: 'Receipt',
    source: 'PO',
    direction: 'In',
    reason: 'Purchase Order',
    sourceTransactionId: 'PO-2025-455',
    transactionTime: '2025-12-10T09:30:00Z',
    createdBy: 'system',
    createdAt: '2025-12-10T09:30:00Z',
    costPrice: 2.10,
    isBom: false,
    match: true,
  },
  {
    transactionId: 7,
    transactionDay: 20251210,
    productId: 106,
    productItemNumber: 'SANDWICH-001',
    productItemDescription: 'Chicken Caesar Sandwich',
    productQuantity: -12,
    productUom: 'EA',
    storeNumber: 'STORE001',
    type: 'Sales',
    source: 'POS',
    direction: 'Out',
    reason: '',
    sourceTransactionId: 'POS-20251210-087',
    transactionTime: '2025-12-10T12:30:00Z',
    createdBy: 'system',
    createdAt: '2025-12-10T12:30:00Z',
    costPrice: 2.75,
    totalSalePriceNet: 4.99,
    totalSalePriceGross: 5.99,
    isBom: true,
    match: true,
    documentId: 1003,
  },
  {
    transactionId: 8,
    transactionDay: 20251210,
    productId: 107,
    productItemNumber: 'JUICE-001',
    productItemDescription: 'Orange Juice 1L',
    productQuantity: 12,
    productUom: 'EA',
    storeNumber: 'STORE001',
    type: 'Transfer',
    source: 'Manual',
    direction: 'In',
    reason: 'Store Transfer',
    sourceTransactionId: 'TRF-2025-123',
    transactionTime: '2025-12-10T16:00:00Z',
    createdBy: 'manager',
    createdAt: '2025-12-10T16:00:00Z',
    costPrice: 1.80,
    productNote: 'Transfer from Store 002',
    isBom: false,
    match: true,
  },
  {
    transactionId: 9,
    transactionDay: 20251209,
    productId: 108,
    productItemNumber: 'PASTA-001',
    productItemDescription: 'Spaghetti 500g',
    productQuantity: -8,
    productUom: 'EA',
    storeNumber: 'STORE001',
    type: 'Sales',
    source: 'POS',
    direction: 'Out',
    reason: '',
    sourceTransactionId: 'POS-20251209-045',
    transactionTime: '2025-12-09T13:15:00Z',
    createdBy: 'system',
    createdAt: '2025-12-09T13:15:00Z',
    costPrice: 0.65,
    totalSalePriceNet: 1.19,
    totalSalePriceGross: 1.49,
    isBom: false,
    match: true,
    documentId: 1004,
  },
  {
    transactionId: 10,
    transactionDay: 20251209,
    productId: 109,
    productItemNumber: 'CHEESE-001',
    productItemDescription: 'Cheddar Cheese 200g',
    productQuantity: 36,
    productUom: 'EA',
    storeNumber: 'STORE001',
    type: 'Receipt',
    source: 'PO',
    direction: 'In',
    reason: 'Purchase Order',
    sourceTransactionId: 'PO-2025-453',
    transactionTime: '2025-12-09T07:45:00Z',
    createdBy: 'system',
    createdAt: '2025-12-09T07:45:00Z',
    costPrice: 2.95,
    isBom: false,
    match: true,
  },
  // ---- Vapiano Transactions (VAP001) ----
  {
    transactionId: 101,
    transactionDay: 20260105,
    productId: 1014,
    productItemNumber: 'VAP-CARBONARA-SALE',
    productItemDescription: 'Spaghetti Carbonara',
    productQuantity: -42,
    productUom: 'EA',
    storeNumber: 'VAP001',
    type: 'Sales',
    source: 'POS',
    direction: 'Out',
    reason: '',
    sourceTransactionId: 'POS-VAP-20260105-001',
    transactionTime: '2026-01-05T22:00:00Z',
    createdBy: 'system',
    createdAt: '2026-01-05T22:00:00Z',
    costPrice: 3.20,
    totalSalePriceNet: 11.63,
    totalSalePriceGross: 13.95,
    isBom: true,
    materials: [
      { materialId: 1, productId: 1014, storeNumber: 'VAP001', itemNumber: 'VAP-FLOUR-001', itemDescription: '00 Flour (Caputo)', costPrice: 18.50, quantity: -4.2, uom: 'kg', match: true },
      { materialId: 2, productId: 1014, storeNumber: 'VAP001', itemNumber: 'VAP-EGGS-001', itemDescription: 'Free Range Eggs', costPrice: 0.12, quantity: -84, uom: 'EA', match: true },
      { materialId: 3, productId: 1014, storeNumber: 'VAP001', itemNumber: 'VAP-GUANCIALE-001', itemDescription: 'Guanciale', costPrice: 28.50, quantity: -3.36, uom: 'kg', match: true },
      { materialId: 4, productId: 1014, storeNumber: 'VAP001', itemNumber: 'VAP-PECORINO-001', itemDescription: 'Pecorino Romano', costPrice: 65.00, quantity: -1.68, uom: 'kg', match: true },
      { materialId: 5, productId: 1014, storeNumber: 'VAP001', itemNumber: 'VAP-OLIVE-001', itemDescription: 'Extra Virgin Olive Oil', costPrice: 24.00, quantity: -0.42, uom: 'Litre', match: true },
    ],
    match: true,
    documentId: 5001,
  },
  {
    transactionId: 102,
    transactionDay: 20260105,
    productId: 1015,
    productItemNumber: 'VAP-MARGHERITA-SALE',
    productItemDescription: 'Pizza Margherita',
    productQuantity: -38,
    productUom: 'EA',
    storeNumber: 'VAP001',
    type: 'Sales',
    source: 'POS',
    direction: 'Out',
    reason: '',
    sourceTransactionId: 'POS-VAP-20260105-002',
    transactionTime: '2026-01-05T22:00:00Z',
    createdBy: 'system',
    createdAt: '2026-01-05T22:00:00Z',
    costPrice: 2.80,
    totalSalePriceNet: 9.96,
    totalSalePriceGross: 11.95,
    isBom: true,
    materials: [
      { materialId: 6, productId: 1015, storeNumber: 'VAP001', itemNumber: 'VAP-FLOUR-001', itemDescription: '00 Flour (Caputo)', costPrice: 18.50, quantity: -9.5, uom: 'kg', match: true },
      { materialId: 7, productId: 1015, storeNumber: 'VAP001', itemNumber: 'VAP-MOZZ-001', itemDescription: 'Fior di Latte Mozzarella', costPrice: 12.80, quantity: -4.75, uom: 'kg', match: true },
      { materialId: 8, productId: 1015, storeNumber: 'VAP001', itemNumber: 'VAP-TOMATO-001', itemDescription: 'San Marzano Tomatoes', costPrice: 4.80, quantity: -3.8, uom: 'kg', match: true },
      { materialId: 9, productId: 1015, storeNumber: 'VAP001', itemNumber: 'VAP-BASIL-001', itemDescription: 'Fresh Basil', costPrice: 1.80, quantity: -114, uom: 'Leaves', match: true },
      { materialId: 10, productId: 1015, storeNumber: 'VAP001', itemNumber: 'VAP-OLIVE-001', itemDescription: 'Extra Virgin Olive Oil', costPrice: 24.00, quantity: -0.57, uom: 'Litre', match: true },
    ],
    match: true,
    documentId: 5002,
  },
  {
    transactionId: 103,
    transactionDay: 20260105,
    productId: 1016,
    productItemNumber: 'VAP-SPRITZ-SALE',
    productItemDescription: 'Aperol Spritz',
    productQuantity: -65,
    productUom: 'EA',
    storeNumber: 'VAP001',
    type: 'Sales',
    source: 'POS',
    direction: 'Out',
    reason: '',
    sourceTransactionId: 'POS-VAP-20260105-003',
    transactionTime: '2026-01-05T22:00:00Z',
    createdBy: 'system',
    createdAt: '2026-01-05T22:00:00Z',
    costPrice: 2.10,
    totalSalePriceNet: 7.92,
    totalSalePriceGross: 9.50,
    isBom: true,
    materials: [
      { materialId: 11, productId: 1016, storeNumber: 'VAP001', itemNumber: 'VAP-APEROL-001', itemDescription: 'Aperol', costPrice: 14.50, quantity: -3.9, uom: 'Litre', match: true },
      { materialId: 12, productId: 1016, storeNumber: 'VAP001', itemNumber: 'VAP-PROSECCO-001', itemDescription: 'Prosecco DOC', costPrice: 6.50, quantity: -5.85, uom: 'Litre', match: true },
    ],
    match: true,
    documentId: 5003,
  },
  {
    transactionId: 104,
    transactionDay: 20260105,
    productId: 1017,
    productItemNumber: 'VAP-GAMBERONI-SALE',
    productItemDescription: 'Spaghetti Gamberoni',
    productQuantity: -18,
    productUom: 'EA',
    storeNumber: 'VAP001',
    type: 'Sales',
    source: 'POS',
    direction: 'Out',
    reason: '',
    sourceTransactionId: 'POS-VAP-20260105-004',
    transactionTime: '2026-01-05T22:00:00Z',
    createdBy: 'system',
    createdAt: '2026-01-05T22:00:00Z',
    costPrice: 4.50,
    totalSalePriceNet: 13.29,
    totalSalePriceGross: 15.95,
    isBom: true,
    materials: [
      { materialId: 13, productId: 1017, storeNumber: 'VAP001', itemNumber: 'VAP-FLOUR-001', itemDescription: '00 Flour (Caputo)', costPrice: 18.50, quantity: -1.8, uom: 'kg', match: true },
      { materialId: 14, productId: 1017, storeNumber: 'VAP001', itemNumber: 'VAP-EGGS-001', itemDescription: 'Free Range Eggs', costPrice: 0.12, quantity: -36, uom: 'EA', match: true },
      { materialId: 15, productId: 1017, storeNumber: 'VAP001', itemNumber: 'VAP-PRAWNS-001', itemDescription: 'King Prawns', costPrice: 18.00, quantity: -2.16, uom: 'kg', match: true },
      { materialId: 16, productId: 1017, storeNumber: 'VAP001', itemNumber: 'VAP-TOMATO-001', itemDescription: 'San Marzano Tomatoes', costPrice: 4.80, quantity: -1.44, uom: 'kg', match: true },
      { materialId: 17, productId: 1017, storeNumber: 'VAP001', itemNumber: 'VAP-OLIVE-001', itemDescription: 'Extra Virgin Olive Oil', costPrice: 24.00, quantity: -0.36, uom: 'Litre', match: true },
    ],
    match: true,
    documentId: 5004,
  },
  {
    transactionId: 105,
    transactionDay: 20260105,
    productId: 1006,
    productItemNumber: 'VAP-MOZZ-001',
    productItemDescription: 'Fior di Latte Mozzarella 1kg',
    productQuantity: -2,
    productUom: 'KG',
    storeNumber: 'VAP001',
    type: 'Waste',
    source: 'Manual',
    direction: 'Out',
    reason: 'Expired',
    transactionTime: '2026-01-05T09:00:00Z',
    createdBy: 'marco.rossi',
    createdAt: '2026-01-05T09:00:00Z',
    costPrice: 12.80,
    productNote: 'Past use-by date - cheese discoloured',
    isBom: false,
    match: true,
  },
  {
    transactionId: 106,
    transactionDay: 20260106,
    productId: 1004,
    productItemNumber: 'VAP-GUANCIALE-001',
    productItemDescription: 'Guanciale (Cured Pork Cheek) 2kg',
    productQuantity: 6,
    productUom: 'EA',
    storeNumber: 'VAP001',
    type: 'Receipt',
    source: 'PO',
    direction: 'In',
    reason: 'Purchase Order',
    sourceTransactionId: 'VAP-2026-001',
    transactionTime: '2026-01-06T07:30:00Z',
    createdBy: 'system',
    createdAt: '2026-01-06T07:30:00Z',
    costPrice: 28.50,
    isBom: false,
    match: true,
  },
  {
    transactionId: 107,
    transactionDay: 20260106,
    productId: 1005,
    productItemNumber: 'VAP-PECORINO-001',
    productItemDescription: 'Pecorino Romano DOP 5kg',
    productQuantity: 2,
    productUom: 'EA',
    storeNumber: 'VAP001',
    type: 'Receipt',
    source: 'PO',
    direction: 'In',
    reason: 'Purchase Order',
    sourceTransactionId: 'VAP-2026-001',
    transactionTime: '2026-01-06T07:30:00Z',
    createdBy: 'system',
    createdAt: '2026-01-06T07:30:00Z',
    costPrice: 65.00,
    isBom: false,
    match: true,
  },
  {
    transactionId: 108,
    transactionDay: 20260104,
    productId: 1009,
    productItemNumber: 'VAP-BASIL-001',
    productItemDescription: 'Fresh Basil (Living Pot)',
    productQuantity: -3,
    productUom: 'EA',
    storeNumber: 'VAP001',
    type: 'Waste',
    source: 'Manual',
    direction: 'Out',
    reason: 'Damaged',
    transactionTime: '2026-01-04T08:30:00Z',
    createdBy: 'marco.rossi',
    createdAt: '2026-01-04T08:30:00Z',
    costPrice: 1.80,
    productNote: 'Plants wilted overnight - fridges too cold',
    isBom: false,
    match: true,
  },
  // ---- Five Guys Transactions (FG001) ----
  {
    transactionId: 201,
    transactionDay: 20260105,
    productId: 2017,
    productItemNumber: 'FG-CHEESEBURGER-SALE',
    productItemDescription: 'Cheeseburger',
    productQuantity: -156,
    productUom: 'EA',
    storeNumber: 'FG001',
    type: 'Sales',
    source: 'POS',
    direction: 'Out',
    reason: '',
    sourceTransactionId: 'POS-FG-20260105-001',
    transactionTime: '2026-01-05T23:00:00Z',
    createdBy: 'system',
    createdAt: '2026-01-05T23:00:00Z',
    costPrice: 3.40,
    totalSalePriceNet: 9.79,
    totalSalePriceGross: 11.75,
    isBom: true,
    materials: [
      { materialId: 101, productId: 2017, storeNumber: 'FG001', itemNumber: 'FG-BEEF-001', itemDescription: 'Fresh Ground Beef Patty', costPrice: 68.00, quantity: -312, uom: 'EA', match: true },
      { materialId: 102, productId: 2017, storeNumber: 'FG001', itemNumber: 'FG-BUNS-001', itemDescription: 'Sesame Seed Bun', costPrice: 18.00, quantity: -156, uom: 'EA', match: true },
      { materialId: 103, productId: 2017, storeNumber: 'FG001', itemNumber: 'FG-CHEESE-001', itemDescription: 'American Cheese Slices', costPrice: 22.50, quantity: -312, uom: 'EA', match: true },
      { materialId: 104, productId: 2017, storeNumber: 'FG001', itemNumber: 'FG-LETTUCE-001', itemDescription: 'Iceberg Lettuce', costPrice: 9.60, quantity: -4.68, uom: 'kg', match: true },
      { materialId: 105, productId: 2017, storeNumber: 'FG001', itemNumber: 'FG-TOMATO-001', itemDescription: 'Fresh Tomato Slices', costPrice: 7.50, quantity: -6.24, uom: 'kg', match: true },
      { materialId: 106, productId: 2017, storeNumber: 'FG001', itemNumber: 'FG-ONION-001', itemDescription: 'White Onion (grilled)', costPrice: 5.00, quantity: -4.68, uom: 'kg', match: true },
    ],
    match: true,
    documentId: 6001,
  },
  {
    transactionId: 202,
    transactionDay: 20260105,
    productId: 2018,
    productItemNumber: 'FG-BACONBURGER-SALE',
    productItemDescription: 'Bacon Cheeseburger',
    productQuantity: -98,
    productUom: 'EA',
    storeNumber: 'FG001',
    type: 'Sales',
    source: 'POS',
    direction: 'Out',
    reason: '',
    sourceTransactionId: 'POS-FG-20260105-002',
    transactionTime: '2026-01-05T23:00:00Z',
    createdBy: 'system',
    createdAt: '2026-01-05T23:00:00Z',
    costPrice: 4.10,
    totalSalePriceNet: 11.04,
    totalSalePriceGross: 13.25,
    isBom: true,
    materials: [
      { materialId: 107, productId: 2018, storeNumber: 'FG001', itemNumber: 'FG-BEEF-001', itemDescription: 'Fresh Ground Beef Patty', costPrice: 68.00, quantity: -196, uom: 'EA', match: true },
      { materialId: 108, productId: 2018, storeNumber: 'FG001', itemNumber: 'FG-BUNS-001', itemDescription: 'Sesame Seed Bun', costPrice: 18.00, quantity: -98, uom: 'EA', match: true },
      { materialId: 109, productId: 2018, storeNumber: 'FG001', itemNumber: 'FG-CHEESE-001', itemDescription: 'American Cheese Slices', costPrice: 22.50, quantity: -196, uom: 'EA', match: true },
      { materialId: 110, productId: 2018, storeNumber: 'FG001', itemNumber: 'FG-BACON-001', itemDescription: 'Smoked Back Bacon', costPrice: 14.50, quantity: -3.92, uom: 'kg', match: true },
      { materialId: 111, productId: 2018, storeNumber: 'FG001', itemNumber: 'FG-LETTUCE-001', itemDescription: 'Iceberg Lettuce', costPrice: 9.60, quantity: -2.94, uom: 'kg', match: true },
      { materialId: 112, productId: 2018, storeNumber: 'FG001', itemNumber: 'FG-TOMATO-001', itemDescription: 'Fresh Tomato Slices', costPrice: 7.50, quantity: -3.92, uom: 'kg', match: true },
    ],
    match: true,
    documentId: 6002,
  },
  {
    transactionId: 203,
    transactionDay: 20260105,
    productId: 2019,
    productItemNumber: 'FG-FRIES-REG-SALE',
    productItemDescription: 'Five Guys Fries (Regular)',
    productQuantity: -210,
    productUom: 'EA',
    storeNumber: 'FG001',
    type: 'Sales',
    source: 'POS',
    direction: 'Out',
    reason: '',
    sourceTransactionId: 'POS-FG-20260105-003',
    transactionTime: '2026-01-05T23:00:00Z',
    createdBy: 'system',
    createdAt: '2026-01-05T23:00:00Z',
    costPrice: 1.20,
    totalSalePriceNet: 4.38,
    totalSalePriceGross: 5.25,
    isBom: true,
    materials: [
      { materialId: 113, productId: 2019, storeNumber: 'FG001', itemNumber: 'FG-POTATO-001', itemDescription: 'Fresh Potatoes (Maris Piper)', costPrice: 8.50, quantity: -73.5, uom: 'kg', match: true },
      { materialId: 114, productId: 2019, storeNumber: 'FG001', itemNumber: 'FG-PEANUT-OIL-001', itemDescription: '100% Refined Peanut Oil', costPrice: 32.00, quantity: -31.5, uom: 'Litre', match: true },
    ],
    match: true,
    documentId: 6003,
  },
  {
    transactionId: 204,
    transactionDay: 20260105,
    productId: 2020,
    productItemNumber: 'FG-CAJUN-FRIES-SALE',
    productItemDescription: 'Cajun Fries (Regular)',
    productQuantity: -145,
    productUom: 'EA',
    storeNumber: 'FG001',
    type: 'Sales',
    source: 'POS',
    direction: 'Out',
    reason: '',
    sourceTransactionId: 'POS-FG-20260105-004',
    transactionTime: '2026-01-05T23:00:00Z',
    createdBy: 'system',
    createdAt: '2026-01-05T23:00:00Z',
    costPrice: 1.30,
    totalSalePriceNet: 4.38,
    totalSalePriceGross: 5.25,
    isBom: true,
    materials: [
      { materialId: 115, productId: 2020, storeNumber: 'FG001', itemNumber: 'FG-POTATO-001', itemDescription: 'Fresh Potatoes (Maris Piper)', costPrice: 8.50, quantity: -50.75, uom: 'kg', match: true },
      { materialId: 116, productId: 2020, storeNumber: 'FG001', itemNumber: 'FG-PEANUT-OIL-001', itemDescription: '100% Refined Peanut Oil', costPrice: 32.00, quantity: -21.75, uom: 'Litre', match: true },
      { materialId: 117, productId: 2020, storeNumber: 'FG001', itemNumber: 'FG-CAJUN-001', itemDescription: 'Cajun Seasoning', costPrice: 8.50, quantity: -0.725, uom: 'kg', match: true },
    ],
    match: true,
    documentId: 6004,
  },
  {
    transactionId: 205,
    transactionDay: 20260105,
    productId: 2021,
    productItemNumber: 'FG-HOTDOG-SALE',
    productItemDescription: 'All-Beef Hot Dog',
    productQuantity: -45,
    productUom: 'EA',
    storeNumber: 'FG001',
    type: 'Sales',
    source: 'POS',
    direction: 'Out',
    reason: '',
    sourceTransactionId: 'POS-FG-20260105-005',
    transactionTime: '2026-01-05T23:00:00Z',
    createdBy: 'system',
    createdAt: '2026-01-05T23:00:00Z',
    costPrice: 2.20,
    totalSalePriceNet: 7.29,
    totalSalePriceGross: 8.75,
    isBom: true,
    materials: [
      { materialId: 118, productId: 2021, storeNumber: 'FG001', itemNumber: 'FG-HOTDOG-001', itemDescription: 'All-Beef Frank', costPrice: 24.00, quantity: -45, uom: 'EA', match: true },
      { materialId: 119, productId: 2021, storeNumber: 'FG001', itemNumber: 'FG-BUNS-001', itemDescription: 'Hot Dog Bun', costPrice: 18.00, quantity: -45, uom: 'EA', match: true },
    ],
    match: true,
    documentId: 6005,
  },
  {
    transactionId: 206,
    transactionDay: 20260105,
    productId: 2022,
    productItemNumber: 'FG-SHAKE-SALE',
    productItemDescription: 'Milkshake (Regular)',
    productQuantity: -72,
    productUom: 'EA',
    storeNumber: 'FG001',
    type: 'Sales',
    source: 'POS',
    direction: 'Out',
    reason: '',
    sourceTransactionId: 'POS-FG-20260105-006',
    transactionTime: '2026-01-05T23:00:00Z',
    createdBy: 'system',
    createdAt: '2026-01-05T23:00:00Z',
    costPrice: 1.80,
    totalSalePriceNet: 5.63,
    totalSalePriceGross: 6.75,
    isBom: true,
    materials: [
      { materialId: 120, productId: 2022, storeNumber: 'FG001', itemNumber: 'FG-SHAKE-BASE-001', itemDescription: 'Vanilla Milkshake Base', costPrice: 15.00, quantity: -25.2, uom: 'Litre', match: true },
    ],
    match: true,
    documentId: 6006,
  },
  {
    transactionId: 207,
    transactionDay: 20260106,
    productId: 2001,
    productItemNumber: 'FG-BEEF-001',
    productItemDescription: 'Fresh Ground Beef Patties 4oz x48',
    productQuantity: 10,
    productUom: 'CASE',
    storeNumber: 'FG001',
    type: 'Receipt',
    source: 'PO',
    direction: 'In',
    reason: 'Purchase Order',
    sourceTransactionId: 'FG-2026-001',
    transactionTime: '2026-01-06T06:20:00Z',
    createdBy: 'system',
    createdAt: '2026-01-06T06:20:00Z',
    costPrice: 68.00,
    isBom: false,
    match: true,
  },
  {
    transactionId: 208,
    transactionDay: 20260106,
    productId: 2012,
    productItemNumber: 'FG-BACON-001',
    productItemDescription: 'Smoked Back Bacon 2.5kg',
    productQuantity: 6,
    productUom: 'CASE',
    storeNumber: 'FG001',
    type: 'Receipt',
    source: 'PO',
    direction: 'In',
    reason: 'Purchase Order',
    sourceTransactionId: 'FG-2026-001',
    transactionTime: '2026-01-06T06:20:00Z',
    createdBy: 'system',
    createdAt: '2026-01-06T06:20:00Z',
    costPrice: 14.50,
    isBom: false,
    match: true,
  },
  {
    transactionId: 209,
    transactionDay: 20260104,
    productId: 2004,
    productItemNumber: 'FG-BUNS-001',
    productItemDescription: 'Sesame Seed Burger Buns x60',
    productQuantity: -1,
    productUom: 'CASE',
    storeNumber: 'FG001',
    type: 'Waste',
    source: 'Manual',
    direction: 'Out',
    reason: 'Damaged',
    transactionTime: '2026-01-04T16:00:00Z',
    createdBy: 'dave.martinez',
    createdAt: '2026-01-04T16:00:00Z',
    costPrice: 18.00,
    productNote: 'Delivery damage - buns crushed',
    isBom: false,
    match: true,
  },
  {
    transactionId: 210,
    transactionDay: 20260105,
    productId: 2003,
    productItemNumber: 'FG-PEANUT-OIL-001',
    productItemDescription: '100% Refined Peanut Oil 20L',
    productQuantity: -1,
    productUom: 'EA',
    storeNumber: 'FG001',
    type: 'Waste',
    source: 'Manual',
    direction: 'Out',
    reason: 'Spillage',
    transactionTime: '2026-01-05T11:30:00Z',
    createdBy: 'dave.martinez',
    createdAt: '2026-01-05T11:30:00Z',
    costPrice: 32.00,
    productNote: 'Fryer overflow during peak service',
    isBom: false,
    match: true,
  },
];

/* ---- Mocked Client Implementation ---- */

import { ITransactionsClient } from '../../interfaces';
export class TransactionsClientMocked implements ITransactionsClient {
  constructor(baseUrl?: string) {}

  async transactions(
    store: string,
    from: string,
    to: string,
    search?: string,
    direction?: string,
    type?: string,
    reason?: string,
    fieldToSort?: string,
    sortDirection?: string,
    skip?: number,
    take?: number,
    source?: string,
    sourceSearch?: string,
    cancelToken?: CancelToken
  ): Promise<SuccessResponse_1OfPagedData_1OfProductTransactionSearch> {
    await delay();
    
    // Start with all transactions - filter by store
    let filtered = [...mockTransactions];

    if (store && store.trim()) {
      filtered = filtered.filter((t) => t.storeNumber === store);
    }

    // Only apply filters if they have specific values (not just defaults)
    if (search && search.trim()) {
      filtered = filtered.filter(
        (t) =>
          (t.productItemNumber || '').toLowerCase().includes(search.toLowerCase()) ||
          (t.productItemDescription || '').toLowerCase().includes(search.toLowerCase())
      );
    }
    
    if (direction && direction.trim()) {
      filtered = filtered.filter((t) => t.direction === direction);
    }
    
    if (type && type.trim() && type !== 'All') {
      filtered = filtered.filter((t) => t.type === type);
    }
    
    if (reason && reason.trim() && reason !== 'All') {
      filtered = filtered.filter((t) => t.reason === reason);
    }
    
    if (source && source.trim()) {
      filtered = filtered.filter((t) => t.source === source);
    }
    
    if (sourceSearch && sourceSearch.trim()) {
      filtered = filtered.filter(
        (t) => (t.sourceTransactionId || '').toLowerCase().includes(sourceSearch.toLowerCase())
      );
    }

    // Apply sorting
    if (fieldToSort) {
      filtered.sort((a, b) => {
        let aVal: any;
        let bVal: any;
        
        // Map common field names
        if (fieldToSort === 'date') {
          aVal = a.transactionTime || '';
          bVal = b.transactionTime || '';
        } else {
          aVal = (a as any)[fieldToSort];
          bVal = (b as any)[fieldToSort];
        }
        
        if (sortDirection === 'desc') {
          return aVal > bVal ? -1 : aVal < bVal ? 1 : 0;
        }
        return aVal > bVal ? 1 : aVal < bVal ? -1 : 0;
      });
    }

    const start = skip || 0;
    const end = start + (take || 10);

    return successResponse({
      data: filtered.slice(start, end) as any,
      totalCount: filtered.length,
      skip: start,
      take: end - start,
    }) as any as SuccessResponse_1OfPagedData_1OfProductTransactionSearch;
  }

  async createMany(body?: CreateMultipleTransactionsRequest, cancelToken?: CancelToken): Promise<void> {
    await delay();
    if (body?.transactions) {
      body.transactions.forEach((t: CreateTransactionRequest) => {
        const date = t.date || new Date().toISOString();
        const dateObj = new Date(date);
        const transactionDay = parseInt(
          `${dateObj.getFullYear()}${String(dateObj.getMonth() + 1).padStart(2, '0')}${String(dateObj.getDate()).padStart(2, '0')}`
        );
        
        mockTransactions.push({
          transactionId: mockTransactions.length + 1,
          transactionDay: transactionDay,
          productId: Math.floor(Math.random() * 1000) + 100,
          productItemNumber: t.itemNumber || '',
          productItemDescription: t.description || '',
          productQuantity: t.quantity || 0,
          productUom: t.uom || 'EA',
          storeNumber: t.store || 'STORE001',
          type: t.type || 'Manual',
          source: t.source || 'Manual',
          direction: (t.quantity || 0) < 0 ? 'Out' : 'In',
          reason: t.reason || '',
          transactionTime: date,
          createdBy: 'user',
          createdAt: date,
          costPrice: t.costPrice || 0,
          productNote: t.note,
          isBom: false,
          match: true,
        });
      });
    }
  }

  async pos(body?: CreateMultiplePosTransactionsRequest, cancelToken?: CancelToken): Promise<void> {
    await delay();
  }

  async rag3(cancelToken?: CancelToken): Promise<SuccessResponse_1OfRAG> {
    await delay();
    return successResponse({ red: 0, amber: 2, green: 156 }) as SuccessResponse_1OfRAG;
  }

  // ====== Auto-generated stub methods ======














    async getbyragstatus2(status: number, cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfIEnumerable_1OfPosFeedLastReceived> {
        throw new Error('Method getbyragstatus2 not implemented in mocked client');
    }

    async clearcache(cancelToken?: CancelToken | undefined): Promise<void> {
        throw new Error('Method clearcache not implemented in mocked client');
    }

    async clearcache2(cache: string, cancelToken?: CancelToken | undefined): Promise<void> {
        throw new Error('Method clearcache2 not implemented in mocked client');
    }

    async voidproduct(body?: FactId | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        throw new Error('Method voidproduct not implemented in mocked client');
    }

    async netsaleswidget(storeNumber: string, cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfList_1OfNetSales> {
        throw new Error('Method netsaleswidget not implemented in mocked client');
    }

}
